import { VerifyOTPScreen } from '@/screens/auth/verify-otp-screen';
export default VerifyOTPScreen;
